import http from "@/services/http";

// Configuração do frete automático da empresa
export const freight = () => {
  async function getOne() {
    const {data} = await http.get('/freight/getOne');
    return data;
  }

  async function update(config) {
    const response = await http.post('/freight/edit', config);
    return response.data;
  }

  async function locateBase(zipcode, number) {
    const response = await http.post('/freight/locateBase', { zipcode, number });
    return response.data;
  }

  async function simulate(zipcode, number, subtotal) {
    const response = await http.post('/freight/simulate', { zipcode, number, subtotal });
    return response.data;
  }

  return {getOne, update, locateBase, simulate};
}
